module.exports = __webpack_public_path__ + "fanzhuan.6932f3a1.png";